// in src/pictures.js

import React from 'react';
import KeyImageField from './components/KeyImageField';
import { 
    List, Datagrid, TextField, EmailField, 
    SingleFieldList, ChipField, ArrayField, DateField,
    SimpleShowLayout, Show
 } from 'react-admin';
import { CardActions } from '@material-ui/core';

export const PictureList = props => (
    <List {...props} 
        actions={<CardActions />} // Hiding all actions (and Export) for now
        bulkActions={false} 
        sort={{ field: 'lastUpdate', order: 'DESC' }}>
        <Datagrid rowClick="show">
            <TextField source="userName" />
            <EmailField source="userEmail" />
            <DateField source="lastUpdate" />
            <ArrayField source="keys" sortable={false}>
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>
            </ArrayField>
        </Datagrid>
    </List>
);

const PostTitle = ({ record }) => {
    return <span>Pictures for {record ? `${record.userName}` : ''}</span>;
};

export const PictureShow = props => (
    <Show title={<PostTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="userName" />
            <EmailField source="userEmail" />
            <DateField source="lastUpdate" />
            <ArrayField source="keys">
                <Datagrid>
                    <TextField source="name" />
                    <KeyImageField source="images" title="name"/>
                    <DateField source="createdOn" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="keys" label="Keys (Debug Mode)">
                <Datagrid>
                    <TextField source="name" />
                    <KeyImageField source="debugImages" title="name" />
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);
